<template>
  <div>
    <section
      class="t1-py-xl position-relative text-white t1-hero-bg t1-section-px"
      id="service-area"
      :style="{ backgroundImage: `url(${cityImage})` }"
    >
      <div class="t1-service-overlay"></div>
      <div class="t1-quote-fade"></div>
      <div class="container-lg position-relative text-center" data-aos="fade-up">
        <div class="eyebrow texttertiary mb-2">Where we work</div>
        <h2 class="font-weight-bold mb-3 text-white">Serving the metro and surrounding counties</h2>
        <p class="text-white-50 mx-auto mb-0" style="max-width: 720px;">
          {{ areas.join('  •  ') }}
        </p>
      </div>
    </section>

    <section class="t1-py-xl backgroundsecondary text-white t1-section-px" id="quote">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-6" data-aos="fade-right">
            <div class="texttertiary mb-2">Free, no-pressure estimate</div>
            <h2 class="font-weight-bold mb-3 text-white">Tell us about the job</h2>
            <p class="text-white-50 mb-4 mb-lg-0">
              Talk to our dispatch team about timing, scope, and next step
            </p>
          </div>

          <div class="col-lg-6" data-aos="fade-left">
            <div
              class="card secondarycardblue border-0 p-4"
              style=""
            >
              <ul class="list-unstyled mb-0">
                <li class="d-flex align-items-start mb-2" v-for="item in contactItems" :key="item.icon">
                  <i :class="['bi', item.icon, 'texttertiary', 'mr-2', 'mt-1']"></i>
                  <a v-if="item.href" :href="item.href" class="text-white notextdeco">{{ item.text }}</a>
                  <span v-else class="text-white">{{ item.text }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Theme1HomePagePart4CTA',
  props: {
    company: { type: Object },
    cityImage: {
      type: String,
      default: 'https://m9.emerld.dev/media/cityimage.jpg',
    },
    areas: {
      type: Array,
      default: () => [
        'Downtown', 'North Ridge', 'Eastgate', 'Westbrook', 'Riverside County',
        'Fairview', 'Millbrook', 'Southport', 'Lake County',
      ],
    },
  },
  computed: {
    contactItems() {
      return [
        { icon: 'bi-telephone-fill', href: `tel:${this.company.phoneHref}`, text: this.company.phone },
        { icon: 'bi-envelope-fill', href: `mailto:${this.company.email}`, text: this.company.email },
        { icon: 'bi-geo-alt-fill', href: null, text: this.company.address },
        { icon: 'bi-clock-fill', href: null, text: this.company.hours },
      ];
    },
  },
};
</script>
